export const SOFTLINE_API_EVENT_SERVICE_EVENTS = 'event-service/events';
